module.exports = KsysAppStartV4dot0dot0;